import { Question, Category } from '../types';

export const categories: Category[] = [
  {
    id: 'self-discovery',
    title: 'Self-Discovery',
    description: 'Understanding your natural inclinations and passions'
  },
  {
    id: 'work-environment',
    title: 'Work Environment Preferences',
    description: 'Identifying your ideal working conditions'
  },
  {
    id: 'values-motivations',
    title: 'Values and Motivations',
    description: 'Exploring what drives and fulfills you'
  },
  {
    id: 'strengths-skills',
    title: 'Strengths and Skills',
    description: 'Assessing your capabilities and potential'
  },
  {
    id: 'future-vision',
    title: 'Future Vision',
    description: 'Envisioning your ideal career path'
  },
  {
    id: 'experimentation',
    title: 'Experimentation and Growth',
    description: 'Identifying opportunities for development'
  }
];

export const questions: Question[] = [
  {
    id: 'time-loss',
    category: 'self-discovery',
    text: 'What activities make me lose track of time because I\'m so engaged?'
  },
  {
    id: 'intrinsic-motivation',
    category: 'self-discovery',
    text: 'What do I enjoy doing even when no one is watching or rewarding me for it?'
  },
  {
    id: 'natural-interests',
    category: 'self-discovery',
    text: 'What subjects or topics do I naturally gravitate towards when reading or learning?'
  },
  {
    id: 'proud-moment',
    category: 'self-discovery',
    text: 'When was the last time I felt really proud of something I did? What was it?'
  },
  {
    id: 'problem-solving',
    category: 'self-discovery',
    text: 'What kind of problems do I love solving?'
  },
  {
    id: 'natural-talents',
    category: 'self-discovery',
    text: 'What comes naturally to me that others find challenging?'
  },
  {
    id: 'recognition-areas',
    category: 'self-discovery',
    text: 'What have others frequently complimented me on or sought my advice about?'
  },
  {
    id: 'team-preference',
    category: 'work-environment',
    text: 'Do I prefer working alone, in small groups, or as part of a large team?'
  },
  {
    id: 'routine-preference',
    category: 'work-environment',
    text: 'Would I rather have a predictable routine or variety and new challenges every day?'
  },
  {
    id: 'pace-preference',
    category: 'work-environment',
    text: 'Do I thrive in fast-paced environments or prefer a slower, more methodical pace?'
  },
  {
    id: 'work-focus',
    category: 'work-environment',
    text: 'Do I like working with data, people, ideas, or things?'
  },
  {
    id: 'environment-energy',
    category: 'work-environment',
    text: 'What kind of work environment makes me feel energized—quiet and structured, or dynamic and flexible?'
  },
  {
    id: 'work-values',
    category: 'values-motivations',
    text: 'What values are most important to me in my work (e.g., creativity, stability, helping others, financial security)?'
  },
  {
    id: 'impact-preference',
    category: 'values-motivations',
    text: 'Would I rather make a difference in people\'s lives or create something tangible?'
  },
  {
    id: 'recognition-importance',
    category: 'values-motivations',
    text: 'Is it important for me to feel recognized for my work, or do I find satisfaction internally?'
  },
  {
    id: 'location-preference',
    category: 'values-motivations',
    text: 'Do I want a career that allows me to travel, work remotely, or stay rooted in one place?'
  },
  {
    id: 'perseverance-areas',
    category: 'values-motivations',
    text: 'What am I willing to struggle for or work hard at, even when it\'s difficult?'
  },
  {
    id: 'top-skills',
    category: 'strengths-skills',
    text: 'What are my top three skills, and how do I enjoy using them?'
  },
  {
    id: 'success-factors',
    category: 'strengths-skills',
    text: 'When I\'ve succeeded in the past, what specific strengths helped me achieve that?'
  },
  {
    id: 'desired-mastery',
    category: 'strengths-skills',
    text: 'What skills would I love to master, even if it takes years?'
  },
  {
    id: 'comparative-advantage',
    category: 'strengths-skills',
    text: 'What do I do better than most people I know?'
  },
  {
    id: 'ideal-workday',
    category: 'future-vision',
    text: 'What does my ideal workday look like from start to finish?'
  },
  {
    id: 'passion-pursuit',
    category: 'future-vision',
    text: 'If money weren\'t an issue, how would I spend my time?'
  },
  {
    id: 'legacy',
    category: 'future-vision',
    text: 'What kind of legacy do I want to leave behind?'
  },
  {
    id: 'future-vision',
    category: 'future-vision',
    text: 'Where do I see myself in five or ten years, both professionally and personally?'
  },
  {
    id: 'new-experiences',
    category: 'experimentation',
    text: 'What\'s something new I\'ve always wanted to try but haven\'t yet?'
  },
  {
    id: 'exploration-opportunities',
    category: 'experimentation',
    text: 'What projects, hobbies, or side gigs could I explore to learn more about my interests?'
  },
  {
    id: 'next-step',
    category: 'experimentation',
    text: 'What\'s the smallest step I could take today to move closer to discovering what I love?'
  }
];